/** Registers the PWA service worker once the page has loaded. */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      console.error('[PWA] Service Worker registration failed:', error);
    });
  });
}

/** Disables pinch / gesture zoom (the layout is designed not to need it). */
export function preventPinchZoom(): void {
  const onTouch = (event: TouchEvent) => {
    if (event.touches.length > 1) event.preventDefault();
  };
  const onGesture = (event: Event) => event.preventDefault();

  document.addEventListener('touchstart', onTouch, { passive: false });
  document.addEventListener('touchmove', onTouch, { passive: false });
  document.addEventListener('gesturestart', onGesture);
  document.addEventListener('gesturechange', onGesture);
  document.addEventListener('gestureend', onGesture);
}
